if (!window.__lazySections) {
  window.__lazySections = true;

  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      el.setAttribute('data-in-view', '');           // for CSS reveals
      el.dispatchEvent(new CustomEvent('lazyvisible')); // for JS-heavy sections
      obs.unobserve(el);                              // fire once, then stop
    });
  }, { rootMargin: '300px 0px' });

  const observe = (root = document) =>
    root.querySelectorAll('[data-lazy]:not([data-in-view])').forEach((el) => io.observe(el));

  observe();
  // re-scan when a section is edited/added in the theme editor
  document.addEventListener('shopify:section:load', (e) => observe(e.target));
}